var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin64(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "64px",
    height: "64px",
    fillRule: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 19,
    y1: 24.858,
    x2: 19,
    y2: 49.041,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 19.382,
    y1: 15.423,
    x2: 19.382,
    y2: 23.341,
    gradientUnits: "userSpaceOnUse",
    id: "color-2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 37.386,
    y1: 14.125,
    x2: 37.386,
    y2: 49.525,
    gradientUnits: "userSpaceOnUse",
    id: "color-3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 32,
    y1: 6.5,
    x2: 32,
    y2: 57.5,
    gradientUnits: "userSpaceOnUse",
    id: "color-4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "none",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,48v-22h-6v22z",
    fill: "url(#color-1)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.358,23c2.512,0 4.076,-1.474 4.076,-3.554c-0.047,-2.126 -1.564,-3.649 -4.028,-3.649c-2.465,0 -4.076,1.475 -4.076,3.601c0,2.08 1.563,3.602 3.981,3.602h0.047z",
    fill: "url(#color-2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.946,48h7.054v-12.089c0,-0.648 0.122,-1.295 0.313,-1.758c0.52,-1.295 1.877,-2.635 3.867,-2.635c2.607,0 3.821,1.988 3.821,4.901v11.581h6v-12.412c0,-6.657 -3.085,-9.498 -7.826,-9.498c-3.886,0 -5.124,1.91 -6.072,3.91h-0.103v-4h-7.054c0.095,2 -0.175,22 -0.175,22z",
    fill: "url(#color-3)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,57h-36c-3.859,0 -7,-3.141 -7,-7v-36c0,-3.859 3.141,-7 7,-7h36c3.859,0 7,3.141 7,7v36c0,3.859 -3.141,7 -7,7zM14,9c-2.757,0 -5,2.243 -5,5v36c0,2.757 2.243,5 5,5h36c2.757,0 5,-2.243 5,-5v-36c0,-2.757 -2.243,-5 -5,-5z",
    fill: "url(#color-4)",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin64);
export default __webpack_public_path__ + "static/media/linkedin-64.02c27997f93620e2a945191e40614560.svg";
export { ForwardRef as ReactComponent };